import React from 'react';

//utils
import { percentager } from '~/utils/helperFunctions';
import { MESSAGES } from '~/utils/message';

// MUI Components
import { Box, Tooltip, Typography } from '@mui/material';

// Icons
import {
  MailedCIcon,
  TransitOrderCIcon,
  DeliveredOrderCIcon,
  RouteCIcon,
  SenderCIcon,
  // ScannedCIcon,
  // NoScannedCIcon,
  // CalenderCIcon,
  ContactInfoCIcon,
} from '~/assets/images';

// Components
import DeliveryInfoSkeleton from './DeliveryInfoSkeleton';

// Styles
import './styles.scss';

function DeliveryInfo({ info, overview, loading }) {
  const deliverableContacts = overview?.deliverableContacts || 0;
  // Restore when uncommenting the scan cards below.
  // const totalContacts = overview?.totalContacts || 0;

  if (loading) {
    return <DeliveryInfoSkeleton />;
  }

  return (
    <Box className="tracking_details_wrapper">
    <Box className="trackingDetailsHeader">
      <Typography variant="h6" className="trackingDetailsTitle">
        Tracking Details
      </Typography>
      <Tooltip
        title={MESSAGES.ORDERS.DETAIL.OVERVIEW.TRACKING_DETAILS_TOOLTIP}
        placement="bottom-start"
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: '12px',
              maxWidth: '300px',
              padding: '8px !important',
            },
          },
        }}
      >
        <img className="trackingDetailsInfoIcon" src={ContactInfoCIcon} alt="info" />
      </Tooltip>
    </Box>
    <Box className="delivery_info_container">
    <Box className="delivery_info">
      <Box className="card_outer">
        <Box className="card">
          <img src={MailedCIcon} alt="icon" />
          <Typography className="amount">{info.orderItemStatuses?.totalMailed || 0}</Typography>
          <span className="txt">{MESSAGES.ORDERS.DETAIL.OVERVIEW.MAILED}</span>
          <Typography className="percentage">
            {percentager(info.orderItemStatuses?.totalMailed || 0, deliverableContacts)}%
          </Typography>
        </Box>
        <Box className="card">
          <img src={TransitOrderCIcon} alt="icon" />
          <Typography className="amount">{info?.orderItemStatuses?.['In Transit']}</Typography>
          <span className="txt">{MESSAGES.ORDERS.DETAIL.OVERVIEW.IN_TRANSIT}</span>
          <Typography className="percentage">
            {percentager(info?.orderItemStatuses?.['In Transit'], deliverableContacts)}%
          </Typography>
        </Box>
          <Box className="card">
          <img src={DeliveredOrderCIcon} alt="icon" />
          <Typography className="amount">{info?.orderItemStatuses?.['Delivered']}</Typography>
          <span className="txt">{MESSAGES.ORDERS.DETAIL.OVERVIEW.DELIVERED}</span>
          <Typography className="percentage">
            {percentager(info?.orderItemStatuses?.['Delivered'], deliverableContacts)}%
          </Typography>
        </Box>
        <Box className="card">
          <img src={RouteCIcon} alt="icon" />
          <Typography className="amount">{info?.orderItemStatuses?.['Re-Routed']}</Typography>
          <span className="txt">{MESSAGES.ORDERS.DETAIL.OVERVIEW.RE_ROUTE}</span>
          <Typography className="percentage">
            {percentager(info?.orderItemStatuses?.['Re-Routed'], deliverableContacts)}%
          </Typography>
        </Box>
        <Box className="card">
          <img className="senderImg" src={SenderCIcon} alt="icon" />
          <Typography className="amount">{info?.orderItemStatuses?.['Returned to Sender']}</Typography>
          <span className="txt">{MESSAGES.ORDERS.DETAIL.OVERVIEW.RETURNED_TO_SENDER}</span>
          <Typography className="percentage">
            {percentager(info?.orderItemStatuses?.['Returned to Sender'], deliverableContacts)}%
          </Typography>
        </Box>
      </Box>
    </Box>

    {/* Temporarily hidden per product request. Keeping the previous scan cards here so
    they can be restored with their original data bindings if tracking details change again.
    <Box className="delivery_info">
    <Box className="card_outer">
        <Box className="card">
          <img src={ScannedCIcon} alt="icon" />
          <Typography className="amount">{info?.geoChart?.scannedOrderItems}</Typography>
          <span className="txt">{MESSAGES.ORDERS.DETAIL.OVERVIEW.SCANNED}</span>
          <Typography className="percentage">
            {percentager(info?.geoChart?.scannedOrderItems, totalContacts)}%
          </Typography>
        </Box>
        <Box className="card">
          <img src={NoScannedCIcon} alt="icon" />
          <Typography className="amount">{info?.geoChart?.notScannedOrderItems}</Typography>
          <span className="txt">{MESSAGES.ORDERS.DETAIL.OVERVIEW.NOT_SCANNED}</span>
          <Typography className="percentage">
            {percentager(info?.geoChart?.notScannedOrderItems, totalContacts)}%
          </Typography>
        </Box>
        <Box className="card">
          <img src={CalenderCIcon} alt="icon" />
          <Typography className="amount">{stepper?.elapsedDays || '-'}</Typography>
          <span className="txt lastTxt">{MESSAGES.ORDERS.DETAIL.OVERVIEW.DAY_ELAPSED}</span>
          <Typography className="percentage"></Typography>
        </Box>
      </Box>
    </Box> */}

    </Box>
    </Box>
  );
}

export default DeliveryInfo;
